<template>
  <div>
    <div class="columns">
      <div class="column is-6">
        <sc-field>
          <sc-button
            @click="addConfigItem()"
            text="Adicionar método"
            theme="primary"
            type="button"/>
        </sc-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="box">
          <sc-table
            :data="clone_quoting_filtered"
            :bordered="true"
            class="sc-files__table"
            :detailed="showDetails"
            detail-key="order"
            :hoverable="false"
            draggable
            :opened-detailed="openedDetail"
            :show-detail-icon="true"
            @dragstart="dragstart"
            @drop="drop"
            @dragover="dragover"
            @dragleave="dragleave">
              <template slot-scope="props">
                <sc-table-column>
                  <sc-icon icon="arrows-alt-v"/>
                </sc-table-column>

                <sc-table-column
                  field="priority"
                  label="Prioridade">
                    {{ props.row.priority }}
                </sc-table-column>

                <sc-table-column
                  field="name"
                  label="Descrição exibida">
                  <sc-field>
                    <sc-input
                      v-model="props.row.name"
                      placeholder="Descrição"/>
                  </sc-field>
                </sc-table-column>

                <slot name="table-fields" :props="props"/>

                <sc-table-column label="Adicionar Ações" v-if="showDetails">
                  <sc-field>
                    <sc-button
                      @click="openDetail(props.row.order)"
                      text="Adicionar ações"
                      theme="primary"
                      type="button"/>
                  </sc-field>
                </sc-table-column>

                <sc-table-column
                  field="status"
                  label="Ativo">
                  <sc-switch v-model="props.row.status"></sc-switch>
                </sc-table-column>

                <sc-table-column label="Ações">
                  <sc-field>
                    <sc-button
                      @click="remove(props.row.order,props.index)"
                      theme="danger"
                      text="X"
                      type="button"/>
                  </sc-field>
                </sc-table-column>
              </template>

              <template class="detail_formated" slot="detail" slot-scope="props">
                <sc-quoting-return-tbl-form-action
                  :action-form="props.row.default_new_action"
                  :only-show="false"
                  :config-index="props.index"
                  @getactionevt="handleEvtAction"/>
                <div class="detail_disabled" v-if="props.row.actions.length > 0">
                  <section
                    class="detail_disabled--item"
                    v-for="(action, actionIndex) in props.row.actions"
                    :key="actionIndex">
                      <sc-quoting-return-tbl-form-action
                        :action-form="action"
                        :only-show="true"
                        :config-index="props.index"
                        @getactionevt="handleEvtAction"/>
                   </section>
                </div>
              </template>

              <template slot="empty">
                <sc-table-empty />
              </template>
          </sc-table>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12 has-text-right">
        <sc-button
          @click="returnConfigList()"
          ref="salvarConfig"
          type="button"
          theme="primary"
          text="Salvar" />
      </div>
    </div>
  </div>
</template>

<script>
  import { Lodash } from '@intelipost-js/secure-providers';
  import {
    ScButton,
    ScField,
    ScIcon,
    ScInput,
    ScSelect,
    ScSwitch,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
  } from '@intelipost-js/secure-components';
  import ScQuotingReturnTblFormAction from './ScQuotingReturnTblFormAction.vue';

  export default {
    name: 'sc-quoting-return-tbl',
    props: {
      quotingData: {
        type: Array,
        default: () => [],
      },
      defaultConfigItem: {
        type: Object,
        required: true,
      },
      showDetails: {
        type: Boolean,
        default: false,
      },
      modeReturnType: {
        type: String,
      },
      modeType: {
        type: String,
      },
    },
    data() {
      return {
        clonedQuoting: [],
        clone_quoting_filtered: [],
        movedRow: {},
        movedRowIndex: 0,
        openedDetail: [],
        actionObj: {
          label: 'FIX_PRICE',
          action_condition: {
            value: 0,
            param: null,
          },
        },
      };
    },
    watch: {
      clonedQuoting() {
        this.clone_quoting_filtered =
          this.clonedQuoting.filter(item => item.mode_type === this.modeType);
      },
      quotingData(newValue) {
        const localclonedQuoting = Lodash.cloneDeep(newValue);

        if (this.showDetails) {
          localclonedQuoting.forEach((item, index) => {
            localclonedQuoting[index].default_new_action = {
              label: 'FIX_PRICE',
              action_condition: {
                value: 0,
                param: null,
              },
            };
          });
        }

        this.clonedQuoting = localclonedQuoting;
      },
      modeType() {
        this.clone_quoting_filtered =
          this.clonedQuoting.filter(item => item.mode_type === this.modeType);
      },
    },
    methods: {
      addAction(action, configItemIdx) {
        const actionIdx = this.findAction(action, configItemIdx);

        if (actionIdx < 0) {
          this.clonedQuoting[configItemIdx]
            .actions
            .push(Lodash.cloneDeep(action));
        } else {
          this.clonedQuoting[configItemIdx].actions[actionIdx] = Lodash.cloneDeep(action);
        }

        this.clonedQuoting[configItemIdx].default_new_action = {
          label: 'FIX_PRICE',
          action_condition: {
            value: null,
            param: null,
          },
        };

        this.clonedQuoting[configItemIdx].default_new_action = {
          label: 'FIX_PRICE',
          action_condition: {
            value: 0,
            param: null,
          },
        };
      },
      addConfigItem() {
        const idx = this.clonedQuoting.length + 1;
        const newConfigItem = Lodash.cloneDeep(this.defaultConfigItem);

        newConfigItem.mode_type = this.modeType;
        newConfigItem.priority = idx;
        newConfigItem.order = idx;
        this.clonedQuoting.push(newConfigItem);
      },
      dragstart(payload) {
        const {
          event = {},
          row,
          index,
        } = payload;

        this.movedRow = row;
        this.movedRowIndex = index;
        event.dataTransfer.effectAllowed = 'move';
      },
      dragover(payload) {
        const {
          event = {},
        } = payload;
        event.dataTransfer.dropEffect = 'move';
        event.target.closest('tr').classList.add('is-selected');
        event.preventDefault();
      },
      dragleave(payload) {
        const { event = {} } = payload;
        const { target = {} } = event;
        target.closest('tr').classList.remove('is-selected');
        event.preventDefault();
      },
      drop(payload) {
        const { event = {} } = payload;
        const { target = {} } = event;
        const destinyRowIndex = payload.index;
        const clonedList = Lodash.cloneDeep(this.clonedQuoting);
        const destinyRow = clonedList[destinyRowIndex];
        const originRow = clonedList[this.movedRowIndex];

        target.closest('tr').classList.remove('is-selected');

        destinyRow.order = this.movedRowIndex + 1;
        destinyRow.priority = this.movedRowIndex + 1;
        originRow.order = destinyRowIndex + 1;
        originRow.priority = destinyRowIndex + 1;

        clonedList[destinyRowIndex] = originRow;
        clonedList[this.movedRowIndex] = destinyRow;

        this.clonedQuoting = [];
        this.clonedQuoting = clonedList;
      },
      editAction(action, configItemIdx) {
        const actionIdx = this.findAction(action);

        this.clonedQuoting[configItemIdx].actions[actionIdx] = action;
        this.actionObj = {
          label: 'FIX_PRICE',
          action_condition: {
            value: 0,
            param: null,
          },
        };
      },
      findAction(action, configItemIdx) {
        return this.clonedQuoting[configItemIdx].actions
          .findIndex(editAction => action.label === editAction.label);
      },
      handleEvtAction({ action, configIndex, evt }) {
        if (evt === 'add') {
          this.addAction(action, configIndex);
        }

        if (evt === 'edit') {
          this.clonedQuoting[configIndex].default_new_action = {};
          this.clonedQuoting[configIndex].default_new_action = action;
          this.removeAction(action, configIndex);
        }

        if (evt === 'delete') {
          this.removeAction(action, configIndex);
        }
      },
      openDetail(row) {
        if (this.openedDetail.indexOf(row) >= 0) {
          this.openedDetail = this.openedDetail.filter(openRow => openRow !== row);
        } else {
          this.openedDetail.push(row);
        }
      },
      remove(order) {
        let indexByOrder = null;
        for (let index = 0; index < this.clonedQuoting.length; index += 1) {
          const element = this.clonedQuoting[index];
          if (element.order === order) {
            indexByOrder = index;
            break;
          }
        }
        this.clonedQuoting.splice(indexByOrder, 1);
        this.clonedQuoting = this.clonedQuoting.map((item, idx) => Object.assign(item, {
          priority: idx + 1,
          order: idx + 1,
        }));
      },
      removeAction(action, configItemIdx) {
        const actionIdx = this.findAction(action, configItemIdx);
        this.clonedQuoting[configItemIdx]
          .actions
          .splice(actionIdx, 1);
      },
      returnConfigList() {
        this.$emit('getconfiglistevt', Lodash.cloneDeep(this.clonedQuoting));
      },
    },
    components: {
      ScButton,
      ScField,
      ScIcon,
      ScInput,
      ScSelect,
      ScSwitch,
      ScTable,
      ScTableColumn,
      ScTableEmpty,
      ScQuotingReturnTblFormAction,
    },
  };
</script>

<style lang="scss" scoped>
  .detail_formated {
    padding: 0 !important;
  }

  .detail_disabled {
    height: 22rem;
    margin-top: .6rem;
    overflow-y: auto;
    padding-right: .8rem;
  }

  .detail_disabled--item {
    border: 1px solid #002716;
    border-radius: 6px;
    padding: .8rem;
    margin-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-return-tbl/ScQuotingReturnTbl.vue?fe77b4b8